<script lang="ts">
	import Footer from '$lib/components/Navigation/Footer.svelte';
	import Navbar from '$lib/components/Navigation/Navbar.svelte';
	import Schedule from '$lib/components/Schedule.svelte';
	import SpaHome from '$lib/components/SpaHome.svelte';
	import WellnessFacilities from '$lib/components/WellnessFacilities.svelte';
	import WellnessSection from '$lib/components/WellnessSection.svelte';
	import type { PageServerData } from './$types';
	export let data: PageServerData;
	let information = data?.information;
	let facilities = data?.facilities;
	let wellness = data?.wellness;
	let spa = data?.spa;
	let schedule = data?.schedule;
</script>

<svelte:head>
	<title>Home - Soham Wellness Center</title>
</svelte:head>
<Navbar />
<div class="relative">
	<img
		class="h-screen w-full object-cover"
		src={information?.data[0]?.images[0]?.path}
		alt="images"
	/>
	<div class="block lg:hidden">
		<div class="absolute top-[5%] z-10 w-full">
			<img src="/images/sohamlogocolor.webp" class="h-[8rem] mx-auto" alt="logo" />
		</div>
	</div>

	<div class="absolute top-[40%] w-full z-10">
		<p class="text-center text-white text-xl lg:text-2xl mb-3">EXPERIENCE</p>
		<h1 class="text-center text-white text-3xl lg:text-5xl gilda font-thin">
			Soham Wellness Center
		</h1>
		<div class="flex justify-center items-center gap-2 mb-2">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="109"
				height="3"
				viewBox="0 0 109 3"
				fill="none"
			>
				<path d="M0.100525 1.89948H108.101" stroke="white" stroke-width="2" />
			</svg>
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="1.41421"
					y="9.89954"
					width="12"
					height="12"
					transform="rotate(-45 1.41421 9.89954)"
					stroke="white"
					stroke-width="2"
				/>
			</svg>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="109"
				height="3"
				viewBox="0 0 109 3"
				fill="none"
			>
				<path d="M0.100525 1.89948H108.101" stroke="white" stroke-width="2" />
			</svg>
		</div>
		<p class="text-center text-white text-md lg:text-xl">Rediscover the essence of wellness</p>
		<div class="flex justify-center mt-7">
			<a
				href="/wellness"
				class="mx-auto text-center text-sm px-5 py-3 bg-white border-[1px] hover:bg-transparent text-[#1F1F1F] hover:text-white"
				>Explore Wellness</a
			>
		</div>
	</div>
	<div
		class="absolute bottom-0 w-full h-full"
		style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%);"
	></div>
</div>
<div class="hidden lg:block container mx-auto px-5 lg:px-16 py-10 lg:py-20">
	<p class="text-[#41818A] text-lg">INDULGE IN HAPPINESS AT</p>
	<h1 class="gilda text-[#41818A] text-5xl">Soham Wellness Center</h1>
	<div class="px-20 py-5">
		<div class="mb-5 flex items-center gap-3">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="108"
				height="3"
				viewBox="0 0 108 3"
				fill="none"
			>
				<path d="M0 1.89954H108" stroke="#41818A" stroke-width="2" />
			</svg>

			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="1.41421"
					y="9.89954"
					width="12"
					height="12"
					transform="rotate(-45 1.41421 9.89954)"
					stroke="#41818A"
					stroke-width="2"
				/>
			</svg>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="108"
				height="3"
				viewBox="0 0 108 3"
				fill="none"
			>
				<path d="M0 1.89954H108" stroke="#41818A" stroke-width="2" />
			</svg>
		</div>
		<p class="text-sm text-[#7A7A7A]">
			Discover SOHAM Wellness Center, a 2021 Indonesia Travel & Tourism Award nominee for Leading
			Luxury Wellness Center. Spanning 2,500 square meters, it offers a serene, elegant space for
			guests to escape, recharge, and enjoy world-class wellness facilities and services. Indulge in
			a complete lifestyle experience with full access to exceptional amenities.
		</p>
	</div>
</div>
<div class="block lg:hidden container mx-auto px-5 lg:px-16 py-10 lg:py-20">
	<p class="text-[#41818A] text-lg mb-2">AT MACA VILLAS & SPA</p>
	<h1 class="gilda text-[#41818A] text-5xl w-1/2">SOHAM Wellness Center</h1>
	<div class="py-5">
		<p class="ps-10 text-sm text-[#7A7A7A]">
			Discover SOHAM Wellness Center, a 2021 Indonesia Travel & Tourism Award nominee for Leading
			Luxury Wellness Center. Spanning 2,500 square meters, it offers a serene, elegant space for
			guests to escape, recharge, and enjoy world-class wellness facilities and services. Indulge in
			a complete lifestyle experience with full access to exceptional amenities.
		</p>
	</div>
</div>
<div class="3xl:container mx-auto">
	<WellnessSection data={wellness} />
</div>
<div class="3xl:container mx-auto grid grid-cols-1 lg:grid-cols-5 items-start">
	<div class=" col-span-2 block md:hidden lg:block">
		<div class="relative min-h-[50vh] lg:min-h-[85vh] 3xl:min-h-[50vh] order-2 lg:order-1">
			<div class="absolute inset-0 bg-[#D5E9E9] w-1/2 h-full"></div>
			<div class="absolute right-0 top-1/2 transform -translate-y-1/2 ps-10">
				<div style="aspect-ratio: 6/5;">
					<img src="/images/abouthero.png" alt="images" class="object-cover w-full h-full" />
				</div>
			</div>
		</div>
	</div>
	<div class="col-span-3 flex items-center justify-center h-full lg:ps-20 order-1 lg:order-2">
		<div class="my-10 lg:my-0 px-5 lg:px-0">
			<p class="text-[#41818A] text-lg">INDULGE IN HAPPINESS AT</p>
			<h1 class="gilda text-[#41818A] font-normal text-5xl mt-4">
				Where Luxury Meets Holistic Care
			</h1>
			<div class="py-3">
				<div class="mb-5 flex items-center gap-3">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="108"
						height="3"
						viewBox="0 0 108 3"
						fill="none"
					>
						<path d="M0 1.89954H108" stroke="#41818A" stroke-width="2" />
					</svg>

					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="1.41421"
							y="9.89954"
							width="12"
							height="12"
							transform="rotate(-45 1.41421 9.89954)"
							stroke="#41818A"
							stroke-width="2"
						/>
					</svg>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="108"
						height="3"
						viewBox="0 0 108 3"
						fill="none"
					>
						<path d="M0 1.89954H108" stroke="#41818A" stroke-width="2" />
					</svg>
				</div>
				<p class="text-sm text-[#7A7A7A] mb-10">
					Discover SOHAM Wellness Center, a 2021 Indonesia Travel & Tourism Award nominee for
					Leading Luxury Wellness Center. Spanning 2,500 square meters, it offers a serene, elegant
					space for guests to escape, recharge, and enjoy world-class wellness facilities and
					services. Indulge in a complete lifestyle experience with full access to exceptional
					amenities.
				</p>
				<a
					href="/about-us"
					class="px-5 py-3 bg-transparent hover:bg-[#41818A] border-[1px] border-[#41818A] text-[#41818A] hover:text-white"
					>About Us</a
				>
			</div>
		</div>
	</div>
</div>
<div class="3xl:container mx-auto">
	<SpaHome data={spa} />
</div>
<section class="py-10">
	<div
		class="bg-bottom bg-cover bg-no-repeat"
		style="background-image: url(/images/schedulebg.png);"
	>
		<h1 class="hidden lg:block text-center gilda text-4xl py-10">Fitness Class Schedule</h1>
		<h1 class="block lg:hidden gilda text-center text-[#41818A] text-4xl mb-5">Schedule</h1>
		<div class="container mx-auto px-5 lg:px-16 lg:pb-20">
			<!-- <Schedule data={schedule} /> -->
			<img src="/images/schedule-soham.webp" alt="/images/schedule-soham.webp" class="mt-5 object-contain" />
			<div class="flex justify-center mt-5">
				<a
					class="bg-[#41818A] text-white w-fit px-5 py-3 uppercase flex items-center gap-3"
					href="/images/schedule-soham.webp"
					download="Schedule.jpg"
					>Download Schedule <svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M21 13.5V19.5C21 19.6989 20.921 19.8897 20.7803 20.0303C20.6397 20.171 20.4489 20.25 20.25 20.25H3.75C3.55109 20.25 3.36032 20.171 3.21967 20.0303C3.07902 19.8897 3 19.6989 3 19.5V13.5C3 13.3011 3.07902 13.1103 3.21967 12.9697C3.36032 12.829 3.55109 12.75 3.75 12.75C3.94891 12.75 4.13968 12.829 4.28033 12.9697C4.42098 13.1103 4.5 13.3011 4.5 13.5V18.75H19.5V13.5C19.5 13.3011 19.579 13.1103 19.7197 12.9697C19.8603 12.829 20.0511 12.75 20.25 12.75C20.4489 12.75 20.6397 12.829 20.7803 12.9697C20.921 13.1103 21 13.3011 21 13.5ZM11.4694 14.0306C11.539 14.1004 11.6217 14.1557 11.7128 14.1934C11.8038 14.2312 11.9014 14.2506 12 14.2506C12.0986 14.2506 12.1962 14.2312 12.2872 14.1934C12.3783 14.1557 12.461 14.1004 12.5306 14.0306L16.2806 10.2806C16.3503 10.2109 16.4056 10.1282 16.4433 10.0372C16.481 9.94613 16.5004 9.84855 16.5004 9.75C16.5004 9.65145 16.481 9.55387 16.4433 9.46283C16.4056 9.37178 16.3503 9.28906 16.2806 9.21937C16.2109 9.14969 16.1282 9.09442 16.0372 9.0567C15.9461 9.01899 15.8485 8.99958 15.75 8.99958C15.6515 8.99958 15.5539 9.01899 15.4628 9.0567C15.3718 9.09442 15.2891 9.14969 15.2194 9.21937L12.75 11.6897V3C12.75 2.80109 12.671 2.61032 12.5303 2.46967C12.3897 2.32902 12.1989 2.25 12 2.25C11.8011 2.25 11.6103 2.32902 11.4697 2.46967C11.329 2.61032 11.25 2.80109 11.25 3V11.6897L8.78063 9.21937C8.63989 9.07864 8.44902 8.99958 8.25 8.99958C8.05098 8.99958 7.86011 9.07864 7.71937 9.21937C7.57864 9.36011 7.49958 9.55098 7.49958 9.75C7.49958 9.94902 7.57864 10.1399 7.71937 10.2806L11.4694 14.0306Z"
							fill="white"
						/>
					</svg></a
				>
			</div>
		</div>
	</div>
</section>

<div class="container mx-auto px-5 lg:px-16 py-20">
	<h1 class="gilda text-center text-[#41818A] text-4xl">Wellness Facilities</h1>
	<WellnessFacilities />
</div>
<Footer />
